export default __webpack_public_path__ + "static/media/qr_tip.00d39b9e.svg";